import React, {useEffect, useState} from "react";
import { Grid, Autocomplete, TextField, FormControl, Select, InputLabel, MenuItem, Button } from "@mui/material";
import UserUtils from "../utils/userUtils";



const UserRoleUpdater = ({users, roleObjs, onSubmit, ...props}) => {
  const [selectedUser, setSelectedUser] = useState();
  const [selectedRole, setSelectedRole] = useState(0);

  useEffect(() => {
    if (selectedUser != null){
      let role = UserUtils.GetHighestRoleObj(selectedUser);
      roleObjs.forEach(element => {
        if (element.value === role.value){
          console.log(element);
          setSelectedRole(element);
        }
      });
    }
  }, [selectedUser])

  const onButtonClick = async () => {
    setSelectedUser(null);
    setSelectedRole(0);
    await onSubmit(selectedUser, selectedRole);
  }



  return (
    <Grid container spacing={(1)} justifyContent={"center"}>
      <Grid item xs={6}>
        <Autocomplete
          disabled={!(users?.length)} 
          options={users}
          getOptionLabel={(opt) => opt?.userName}
          value={selectedUser}
          onChange={(e, newVal) => setSelectedUser(newVal)}
          renderInput={(params) => <TextField
            {...params}
            variant="standard"
            label="Select a User"
            aria-label="select user combo box"
          />}
        />
      </Grid>

      <Grid item xs={6}>
        <FormControl fullWidth>
          <InputLabel id="role-select-label">Select Role</InputLabel>
          <Select
             label="Select Role"
             labelId="role-select-label"
             value={selectedRole}
             onChange={(e) => setSelectedRole(e.target.value)}
             disabled={selectedUser == null}
          >
            {roleObjs && roleObjs.map(role => 
              <MenuItem value={role} key={role.value}>{UserUtils.RoleObjToRoleString(role)}</MenuItem>
            )}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={4}>
        <Button fullWidth variant="contained"
          disabled={selectedUser == null || !(selectedRole)}
          onClick={onButtonClick}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  )
}

export default UserRoleUpdater;